import { z } from 'zod';

/**
 * Zod-схемы контракта наград и лидерборда (Веха 9).
 *
 * Strict-объекты — неизвестные поля отвергаются (CANON D2).
 * Response-схемы содержат ТОЛЬКО агрегаты/уровни — без userId, без identity
 * (threat-model rewards.md I.a).
 */

export const RewardBadgeEnum = z.enum([
  'viral_starter',
  'storyteller',
  'loop_master',
]);

export const RewardThemeEnum = z.enum(['confession', 'guesswho']);

/**
 * Response `GET /me/rewards`.
 *
 * `nextLevelAt` — сколько confirmed-рефералов нужно для следующего уровня
 * (null = максимальный уровень достигнут).
 */
export const RewardsResponse = z
  .object({
    level: z.number().int().min(0),
    badges: z.array(RewardBadgeEnum),
    themes: z.array(RewardThemeEnum),
    confirmedReferrals: z.number().int().min(0),
    nextLevelAt: z.number().int().positive().nullable(),
  })
  .strict();
export type RewardsResponse = z.infer<typeof RewardsResponse>;
